<template>
    <div>
        <div @click="test">adddd</div>
        <ul class="items">
            <li class="item" v-for="(item,index) in list" :style="{height:item + 'px'}" :key="index">
                {{item}}
            </li>
        </ul>
    </div>
   
</template>

<script>
export default {
   data (){
       return {
            list:[100,130,140,150,160,170,180,190,240,110,120],
       }
   },
   components: {
       
   },
   watch: {
       
   },
   computed: { 
       
   },
   methods: { 
       test(){
           this.list = this.list.concat(this.list)
       }
   },
   created() {
       
   },
   mounted() {
       
   }
}
</script>

<style scoped lang='less'>
.items{
    // column-count: 2;
}
.item{
    background:red;
    margin-bottom:10px;
    width: 50%;
    float: left;
    // display: flex;
    // flex-direction: column;
    // justify-content: center;
    // break-inside: avoid;
}
</style>



// WEBPACK FOOTER //
// src/pages/test.vue